<template>
  <div class="attachment">
    <tk-flex middle v-if="edit">
      <div class="label fill">
        附件
      </div>
      <v-btn flat @click.native="add">
        <v-icon>add</v-icon> 添加附件
      </v-btn>
    </tk-flex>
    <v-list two-line class="list">
      <v-list-tile v-for="item in loadingFiles" :key="item.filename" avatar>
        <v-list-tile-avatar>
          <v-icon>insert_drive_file</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.filename }}</v-list-tile-title>
        </v-list-tile-content>
        <div class="actions">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
      </v-list-tile>
      <v-list-tile v-for="(item, index) in files" :key="item.url" avatar>
        <v-list-tile-avatar>
          <v-icon v-if="isImage(item)">insert_photo</v-icon>
          <v-icon v-else>insert_drive_file</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title><a class="file-name" @click="getFile(item)">{{ item.name }}</a></v-list-tile-title>
          <v-list-tile-sub-title>上传于 {{ item.date | date}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <div class="actions" v-if="edit">
          <v-btn icon @click="changeName(item)">
            <v-icon color="grey lighten-1">edit</v-icon>
          </v-btn>
          <v-btn icon @click="del(index)">
            <v-icon color="grey lighten-1">clear</v-icon>
          </v-btn>
        </div>
      </v-list-tile>
    </v-list>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-text>
          <v-text-field label="文件名" v-model="name"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="dialog = false">取消</v-btn>
          <v-btn color="primary" flat @click.native="saveName">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <viewer
      :images="images"
      class="viewer" @inited="inited"
    >
      <template v-slot="scope" v-if="showPreview">
        <img v-for="src in scope.images" :src="src" :key="src" class="hide">
      </template>
    </viewer>
  </div>
</template>
<script>
export default {
  name: 'attachment',
  data () {
    return {
      dialog: false,
      name: '',
      current: null,
      loadingFiles: [],
      preview: '',
      showPreview: false,
      empty: [],
      files: []
    }
  },
  watch: {
    value () {
      if (this.value !== this.files) this.files = this.value
    },
    files (val) {
      this.$emit('input', val)
    }
  },
  computed: {
    images () {
      return this.files.filter(file => {
        return this.isImage(file)
      }).map(img => img.url)
    }
  },
  mounted () {
    if (this.value) this.files = this.value
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    },
    isImage (file) {
      let imgExt = ['png', 'jpg', 'jpeg', 'gif', 'bmp']
      return imgExt.includes(file.ext.toLowerCase())
    },
    async getFile (file) {
      let url = this.getUrl(file)
      if (!this.isImage(file)) {
        window.open(url)
      } else {
        this.showPreview = true
        await this.$nextTick()
        this.$viewer.update()
        let index = this.images.findIndex(i => i === file.url)
        this.$viewer.show()
        this.$viewer.view(index)
      }
    },
    saveName () {
      this.dialog = false
      this.$set(this.current, 'name', this.name)
    },
    changeName (item) {
      this.dialog = true
      this.current = item
      this.name = item.name
    },
    getUrl (item) {
      return item.url
    },
    async add () {
      let file = await this.$tkFile.pick({
        type: '*',
        compress: false
      }).catch(e => {})
      if (!file) return
      let data = this.$tkFile.createFormData({
        file: file
      })
      this.loadingFiles.push({
        filename: file.name
      })
      let rs = await this.$apiAjax.post('/file', data, {
        timeout: 600000
      }).catch(e => {
        this.$tkGlobal.alert.show('文件上传失败')
      })
      let index = this.loadingFiles.findIndex(item => item.filename === file.name)
      this.loadingFiles.splice(index, 1)
      if (!rs) return
      this.files.push({
        name: file.name,
        url: rs.data.url,
        ext: file.ext,
        date: new Date().toISOString()
      })
    },
    del (index) {
      this.files.splice(index, 1)
    }
  },
  props: {
    value: Array,
    edit: Boolean
  }
}
</script>
<style lang="scss" scoped>
  .actions button {
    margin-right: 0;
  }
  .list {
    margin-left: -16px;
   .file-name {
     word-break: break-all;
     white-space: normal;
   }
  }
  .img-box {
    overflow: auto;
    max-height: 100%;
    max-width: 100%;
  }
  .hide {
    display: none;
  }
</style>
